module.exports = "/static/images/serial_number.svg";